module.exports = __webpack_public_path__ + "img/MBA.dde9e076.png";